import React, { useState, useEffect } from "react";
import {
  useSelector,
} from "../../components/hooks/hooks";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backendApi } from "../../api/apiService";
function OfficeDetails({ candidate, candidateInit,fieldDisableOrNot }) {
  const noticePeriods = ['1 Month', '2 Month', '3 Month', '4 Month'];
  const [editedCandidate, setEditedCandidate] = useState({ ...candidate });
  const { awsData, recuitmentStatus } = useSelector(
    (state) => state.commonData
  );
  const handleInputChange = (e) => {
    if(!fieldDisableOrNot){
    const { name, value } = e.target;
    setEditedCandidate({ ...editedCandidate, [name]: value });
    }
  };
  const updateProfile = () => {
    var req = {
      "functionName": "candidateOfficeDetailsUpdate",
      "candidate_id": editedCandidate.id,
      "total_experiance": editedCandidate?.total_experiance,
      "ctc": editedCandidate?.ctc,
      "ectc": editedCandidate?.ectc,
      "location": editedCandidate?.location,
      "preferredLocation": editedCandidate?.preferredLocation,
      "relocate": editedCandidate?.relocate,
      "notice_period": editedCandidate?.notice_period,
      "remarks": editedCandidate?.remarks,
      "status": editedCandidate?.status
    }
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Profile Updated succesfully", { containerId: "P" });
        setTimeout(() => {
          candidateInit()
        }, 1000);
      } else {
        toast.warn("Something went wrong, please try again", {
          containerId: "P",
        });
      }
    });
  }
  const renderNoticePeriods = () => {
    return noticePeriods.map((period, index) => (
      <span
        key={index}
        disabled={fieldDisableOrNot}
        name="notice_period"
        className={`skill-span me-1 ${editedCandidate?.notice_period === period && 'active'}`}
        onClick={() => handleInputChange({ target: { name: 'notice_period', value: period } })}
      >
        {period}
      </span>
    ));
  };
  return (
    <div className="cardDeatils">
      <ToastContainer
        enableMultiContainer
        containerId={"P"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="sub-head">Office Details</div>
      <div className="cardData ">
        <div className="row xilliFirst">
          <div className="col-md-6">
            <div className="form-group">
              <label for="" className="form-label">Total Experience(In Years) :</label>
              <input
                type="text"
                disabled={fieldDisableOrNot}
                className="form-control"
                name="total_experiance"
                placeholder="Enter total experience in years..."
                value={editedCandidate?.total_experiance && editedCandidate?.total_experiance != "undefined" ? editedCandidate?.total_experiance : ""}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label for="" className="form-label">CTC :</label>
              <input
                type="text"
                placeholder="Enter ctc"
                className="form-control"
                name="ctc"
                disabled={fieldDisableOrNot}
                value={editedCandidate?.ctc && editedCandidate?.ctc != "undefined" ? editedCandidate?.ctc : ""}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label for="" className="form-label">Preferred Location :</label>
              <input
                type="text"
                placeholder="Enter preferred location"
                className="form-control"
                name="preferredLocation"
                disabled={fieldDisableOrNot}
                value={editedCandidate?.preferredLocation && editedCandidate?.preferredLocation != "undefined" ? editedCandidate?.preferredLocation : ""}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label for="" className="form-label">Notice Period :</label>
              <div className="noticePer" >
                {renderNoticePeriods()}
              </div>
            </div>
            <div className="form-group">
              <label for="" className="form-label">Remarks :</label>
              <textarea
                type="text"
                placeholder="Remarks"
                className="form-control"
                name="remarks"
                disabled={fieldDisableOrNot}
                value={editedCandidate?.remarks && editedCandidate?.remarks != "undefined" ? editedCandidate?.remarks : ""}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label for="" className="form-label">Location:</label>
              <input
                type="text"
                disabled={fieldDisableOrNot}
                className="form-control"
                placeholder="Enter location.."
                name="location"
                value={editedCandidate?.location && editedCandidate?.location != "undefined" ? editedCandidate?.location : ""}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="form-group">
              <label for="" className="form-label">Expected CTC:</label>
              <input
                type="text"
                className="form-control"
                disabled={fieldDisableOrNot}
                placeholder="Enter expected ctc"
                name="ectc"
                value={editedCandidate?.ectc && editedCandidate?.ectc != "undefined" ? editedCandidate?.ectc : ""}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className="form-group">
              <label for="" className="form-label">Willing to Relocate:</label>
              <select
               disabled={fieldDisableOrNot}
                className="form-control"
                name="relocate"
                value={editedCandidate.relocate}
                onChange={handleInputChange}
              >
                <option value="">-Select-</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
            <div className="form-group">
              <label for="" className="form-label">Application Status:</label>
              <select
               disabled={fieldDisableOrNot}
                className="form-control"
                name="status"
                value={editedCandidate.status}
                onChange={handleInputChange}
              >
                <option value="">-Select-</option>
                {recuitmentStatus?.length > 0 &&
                  recuitmentStatus?.map((data) => {
                    return (
                      <>
                        <option value={data}>{data}</option>
                      </>
                    );
                  })}
              </select>
            </div>
          </div>
          {! fieldDisableOrNot?
          <div className="col-md-12">
            <div className="childIssueses"  >
              <a className="btn-btn btn btn-btn2 btn-sm me-2" onClick={(e) => updateProfile()}>Update</a>
              <a className="btn-btn btn btn-btn1 btn-sm" onClick={(e) => setEditedCandidate({ ...candidate })}>Reset</a>
            </div>
          </div>:""}
        </div>
      </div>
    </div>
  );
}
export default OfficeDetails;
